import validate from "/var/www/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/var/www/app/apps/web/middleware/auth.global.ts";
import manifest_45route_45rule from "/var/www/app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  authenticated: () => import("/var/www/app/apps/web/middleware/authenticated.ts"),
  guest: () => import("/var/www/app/apps/web/middleware/guest.ts")
}